import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { ERideEventName, IRideTransitionSelectedEvent, TRideEntryPointViewedEvent } from './types';

export type { TRideEntryPointViewedEvent } from './types';
export { ERideTransitionPlacement } from './types';

/**
 * Fired whenever a user clicks through from Outdoorsy to ride.auto, the sister
 * car-rental marketplace — the cross-marketplace complement to the UTM params
 * carried on the destination URLs.
 */
export const trackRideTransitionSelectedEvent = (event: IRideTransitionSelectedEvent) => {
  trackEventV2(ERideEventName.RIDE_TRANSITION_SELECTED, EProjectSection.MARKETPLACE, { ...event });
};

/** Once per placement per page view — see useRideEntryPointImpression */
export const trackRideEntryPointViewedEvent = (event: TRideEntryPointViewedEvent) => {
  trackEventV2(ERideEventName.RIDE_ENTRY_POINT_VIEWED, EProjectSection.MARKETPLACE, { ...event });
};
